<template>
    <div class="login">
        <main-container>
            <v-row>
                <v-col class="left" cols="12" lg="5">
                    <typo name="title-30-normal">
                        {{ dico.title }}
                    </typo>
                    <typo name="title-18-bold">
                        {{ dico.subtitle }}
                    </typo>
                    <sep name="M"></sep>
                    <typo name="body-16-light">
                        {{ dico.body1 }}
                    </typo>
                    <sep name="M"></sep>
                    <typo name="body-16-light">
                        {{ dico.body2 }}
                    </typo>
                </v-col>
                <v-col class="right">
                    <slot></slot>
                </v-col>
            </v-row>
            <v-snackbar
                class="snackbar"
                v-model="snackbarOpen"
                :color="_snackbar.color"
                :timeout="12000"
                :top="true"
            >
                {{ _snackbar.text }}
                <v-btn dark text @click="onSnackbarClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-snackbar>
        </main-container>
    </div>
</template>

<script>
export default {
    components: {},
    props: ["snackbar"],
    data() {
        return {
            snackbarOpen: false,
        };
    },
    watch: {
        snackbar: function (newVal) {
            this.snackbarOpen = !!newVal && !!newVal.text;
        },
    },
    computed: {
        dico() {
            return this.$publicDico.login;
        },
        _snackbar() {
            return this.snackbar || {};
        },
    },
    methods: {
        onSnackbarClose() {
            this.$emit("snackbar:close");
        },
    },
};
</script>

<style lang="sass" scoped>

.main-container
    max-width: 900px !important

.left
    padding: $padding-main
    display: flex
    flex-direction: column
    background: $color-pink
    +r(480)
        padding: 16px

    .title-18-bold
        margin-top: 10px

.right
    background: $color-background
    padding: $padding-main
    +r(480)
        padding: 16px

.snackbar
    top: 180px
</style>
